import * as client from './client';
import { StoreApiError, type StartCheckoutSessionInput } from './types';

interface UrlResponse {
  url: string;
}

/**
 * Creates a Stripe Checkout session via alchemie-commerce `createCheckoutSession`
 * and redirects the browser to Stripe. On success the function does not return
 * (the redirect unwinds the call stack).
 */
export async function startCheckoutSession(input: StartCheckoutSessionInput): Promise<void> {
  const body: Record<string, unknown> = {
    productId: input.productId,
    successUrl: input.successUrl,
    cancelUrl: input.cancelUrl,
  };
  if (input.intent) {
    body.intent = input.intent;
  }

  const { url } = await client.fetchJson<UrlResponse>({
    method: 'POST',
    relativePath: '/createCheckoutSession',
    body,
    errorContext: 'Checkout',
  });

  if (!url) {
    throw new StoreApiError('invalid-response', 'Billing server did not return a checkout URL.');
  }

  client.redirectTo(url);
}
